/* ════════════════════════════════════════════════════════════════════
   ISOFIN® Online-Handbuch — handbuch.js
   - Mobile-Drawer (Burger) öffnen/schließen
   - Scroll-Spy: aktiven Abschnitt in Sidebar + Drawer markieren
   - Unter-Navigation automatisch aus den <h2 class="hb-h2"> der Seite bauen
   - Lese-Fortschrittsbalken (.hb-progress-bar > i)
   - Seitenleiste: aktuelles Kapitel markieren und in Sicht holen (v639)
   Vanilla JS, defer-geladen. Namespace-frei, nur .hb-* Selektoren.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var root = document.querySelector('.hb-root');
  if (!root) return;

  /* ---- 1) Mobile-Drawer ------------------------------------------------ */
  var drawer = root.querySelector('.hb-drawer');
  /* v576: Das Verzeichnis im Drawer wird beim ersten Öffnen aus der Seitenleiste kopiert (steht nur einmal im HTML). */
  function fuelleDrawer() {
    var ziel = drawer && drawer.querySelector('[data-hb-toc-klon]');
    var quelle = root.querySelector('.hb-side .hb-toc');
    if (ziel && quelle && !ziel.firstChild) ziel.appendChild(quelle.cloneNode(true));
  }
  function openDrawer()  { if (drawer) { fuelleDrawer(); drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }
  root.addEventListener('click', function (e) {
    if (e.target.closest('.hb-mnav-btn'))      { openDrawer(); }
    if (e.target.closest('.hb-drawer-close'))  { closeDrawer(); }
    if (e.target.closest('.hb-drawer a')) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---- 2) Unter-Navigation aus H2 generieren --------------------------- */
  var article = root.querySelector('.hb-article');
  var heads = article ? Array.prototype.slice.call(article.querySelectorAll('h2.hb-h2[id]')) : [];

  function buildSubnav(host) {
    if (!host || !heads.length) return null;
    var ul = document.createElement('ul');
    ul.className = 'hb-subnav';
    heads.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'hb-subnav-link';
      a.href = '#' + h.id;
      a.textContent = h.getAttribute('data-nav') || h.textContent;
      li.appendChild(a); ul.appendChild(li);
    });
    host.appendChild(ul);
    return ul;
  }
  // unter dem aktuell aktiven Cluster (Sidebar + Drawer) einhängen
  var subnavs = [];
  root.querySelectorAll('.hb-nav-item.is-current').forEach(function (item) {
    var sn = buildSubnav(item);
    if (sn) subnavs.push(sn);
  });

  /* ---- 3) Scroll-Spy + Fortschritt ------------------------------------ */
  var links = root.querySelectorAll('.hb-subnav-link');
  var bar = root.querySelector('.hb-progress-bar > i');

  function onScroll() {
    var y = window.scrollY + 100;
    var current = null;
    heads.forEach(function (h) { if (h.offsetTop <= y) current = h.id; });
    links.forEach(function (a) {
      a.classList.toggle('is-active', a.getAttribute('href') === '#' + current);
    });
    if (bar) {
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (docH > 0 ? Math.min(100, (window.scrollY / docH) * 100) : 0) + '%';
    }
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(function () { onScroll(); ticking = false; }); ticking = true; }
  }, { passive: true });
  onScroll();

  /* ---- 4) Seitenleiste: aktuelles Kapitel markieren und in Sicht holen --
     v639: Die Seitenleiste hat einen eigenen Scrollbereich und stand beim Laden
     immer oben. Jetzt springt sie zum Kapitel der aufgerufenen Seite, damit
     dessen Unterpunkte sofort zu sehen sind. Der Drawer kopiert die Markierung mit. */
  var sideScroll = root.querySelector('.hb-side-scroll');
  if (sideScroll) {
    var pfad = location.pathname.replace(/\/$/, '');
    var treffer = Array.prototype.filter.call(sideScroll.querySelectorAll('.hb-toc a[href]'), function (a) {
      return a.pathname.replace(/\/$/, '') === pfad;
    });
    if (treffer.length) {
      treffer.forEach(function (a) { a.classList.add('is-current'); });
      treffer[0].setAttribute('aria-current', 'page');
      var block = treffer[0].closest('.hb-toc-grp') || treffer[0].closest('li') || treffer[0];
      sideScroll.scrollTop += block.getBoundingClientRect().top - sideScroll.getBoundingClientRect().top - 12;
    }
  }
})();
